import { render, staticRenderFns } from "./CoButtonGroup.vue?vue&type=template&id=365a45f3&scoped=true&"
import script from "./CoButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./CoButtonGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CoButtonGroup.vue?vue&type=style&index=0&id=365a45f3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a45f3",
  null
  
)

export default component.exports